export enum EResource {
    watabi = 'watabi',
    externalService = 'external-services',
    bookings = 'bookings',
}